// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".6926d4c5bd03c1dd140f58473e2a0d90b0ebf414.chunk.js";
};